<template>
  <div class="choice-character__slide">
    <div class="slide-parent">
      <div class="slide-translate" :style="{ transform: translate, width: width }">
        <div class="slide-item" v-for="(player, i) in dataPlayer" :class="[i === 0 ? 'active' : '', i === 1 ? 'next-active' : '']">
          <template v-if="!getMobile">          
            <h2 class="title">{{ player.name }}</h2>

            <div class="slide-player__box">
              <div>
                <div class="slide-player__img">
                  <img :src="player.img" alt="player.name">
                </div>

                <div class="slide-player__infos">
                  <div>
                    <p><span>Age :</span> <span>{{ player.age }}</span></p>
                    <p><span>Taille :</span> <span>{{ player.size }}</span></p>
                    <p><span>Nationalité :</span> <span>{{ player.country }}</span></p>
                    <p><span>Poste :</span> <span>{{ player.role }}</span></p>
                  </div>

                  <div class="slide-player__descr">
                    <p v-html="player.descr"></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="slide-player__go-container">
              <router-link to="/valider-son-personnage" class="slide-player__go btn" @click.native="setPlayer">
                Jouer avec {{ player.name }}
              </router-link>
            </div>
          </template>

          <template v-else>
            <h2 class="title">{{ player.name }}</h2>

            <div class="slide-player__box">
              <div>
                <div class="slide-player__infos">
                  <div>
                    <p><span>Age :</span> <span>{{ player.age }}</span></p>
                    <p><span>Taille :</span> <span>{{ player.size }}</span></p>
                    <p><span>Nationalité :</span> <span>{{ player.country }}</span></p>
                    <p><span>Poste :</span> <span>{{ player.role }}</span></p>
                  </div>

                  <div class="slide-player__img">
                    <img :src="player.img" alt="player.name">
                  </div>

                  <div class="slide-player__go-container">
                    <router-link to="/valider-son-personnage" class="slide-player__go btn" @click.native="setPlayer">
                      Jouer avec {{ player.name }}
                    </router-link>
                  </div>

                  <div class="slide-player__descr">
                    <p v-html="player.descr"></p>
                  </div>
                </div>
              </div>
            </div>            
          </template>
        </div>
      </div>

      <transition name="fadeIn">
        <button class="slide-btn slide-btn--prev" v-if="actual !== 0" @click="prevSlide"></button>
      </transition>

      <transition name="fadeIn">
        <button class="slide-btn slide-btn--next" v-if="actual !== dataPlayer.length - 1" @click="nextSlide"></button>
      </transition>
    </div>
  </div>
</template>

<script>
  import Cookie from 'js-cookie';
  import Transition from '~mixins/Transition';
   
  export default {
    name: 'choice-character-slide',
    mixins: [Transition],
    data() {
      const _containerW = window.innerWidth;

      return {
        dataPlayer: this.$store.getters.getCharactersData,
        width: 0,
        containerW: _containerW,
        translate: 'translateX(0)',
        actual: this.$store.getters.getCharacterPos,
      };
    },
    mounted() {
      const self = this;

      this.slideParent = this.$el.querySelector('.slide-parent');
      this.slideTranslate = this.$el.querySelector('.slide-translate');
      this.slideItems = this.$el.querySelectorAll('.slide-item');

      this.setSliderSize();

      setTimeout(() => {
        self.slideTranslate.style.transition = 'transform .6s ease-in-out';
      }, 500);

      window.addEventListener('resize', () => {
        self.containerW = window.innerWidth;
        self.setSliderSize();
      });
    },
    methods: {
      setSliderSize() {
        this.width = `${this.slideItems.length * this.containerW}px`;
        const perc = window.innerWidth;

        if (this.$store.getters.getCharacterPos) {
          const _translate = -perc * (this.$store.getters.getCharacterPos);
          this.translate = `translateX(${_translate}px)`;

          this.resetClass();
          this.setClass();
        }
      },
      resetClass() {
        for (let m = 0; m < this.slideItems.length; m += 1) {
          this.slideItems[m].classList.remove('active');
          this.slideItems[m].classList.remove('prev-active');
          this.slideItems[m].classList.remove('next-active');
        }
      },
      setClass() {
        const _translate = -this.containerW * (this.actual);
        this.translate = `translateX(${_translate}px)`;

        this.slideItems[this.actual].classList.add('active');

        if (this.slideItems[this.actual + 1]) {
          this.slideItems[this.actual + 1].classList.add('next-active');
        }

        if (this.slideItems[this.actual - 1]) {
          this.slideItems[this.actual - 1].classList.add('prev-active');
        }
      },
      prevSlide() {
        this.actual -= 1;
        this.resetClass();
        this.setClass();
      },
      nextSlide() {
        this.actual += 1;
        this.resetClass();
        this.setClass();
      },
      setPlayer() {
        this.$store.commit('setPlayer', this.$store.getters.getCharactersData[this.actual]);
        this.$store.commit('setCharactersPos', this.actual);
        this.$store.commit('setTmpPlayer', this.$store.getters.getCharactersData[this.actual].name);
        this.$store.commit('setMoney', this.$store.getters.getCharactersData[this.actual].start);

        this.$store.commit('setActualQuestion', '1');
        this.$store.commit('setCycle', 'reset');

        Cookie.set('player', this.$store.getters.getCharactersData[this.actual], 7);
        Cookie.set('money', this.$store.getters.getCharactersData[this.actual].start, 7);
        Cookie.remove('question');

        this.$store.commit('setQuestionCycle', {
          index: 1,
          data: null,
        });
      },
    },
    computed: {
      getMobile() {
        return this.$store.getters.getMobile;
      },
    },
  };
</script>


<style lang="scss">
  .choice-character__slide {
    width: 100%;
  }

  .slide-parent {
    position: relative;
    padding: 0 0 50px;
    overflow: hidden;
    opacity: 0;
    animation: appearBottom .4s ease-in-out forwards;

    .title {
      animation: titleAppear .4s .3s ease-in-out forwards;
    }

    .slide-translate {
      display: flex;
      width: 100%;
      align-items: center;
      // transition: transform .6s ease-in-out;

      @include mobile {
        align-items: flex-start;
      }
    }

    .slide-item {
      width: calc(100% / 4);
    }
  }

  .slide-item {
    position: relative;
    opacity: 0;
    @include defaultTransition(.4);

    &.active {
      opacity: 1;
    }

    .slide-player__box,
    .slide-player__preview {
      background: rgba($white, .6);
      box-shadow: 0 0 10px 0 rgba($black, 0.6);
    }

    .slide-player__box {
      width: 80%;
      max-width: 650px;
      height: 350px;
      margin: auto;

      @include mobile {
        width: 96%;
        height: auto;
      }

      img {
        max-width: 180px;
      }

      > div {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 25px 20px;

        @include mobile {
          display: block;
        }
      }

      img {
        position: relative;
        left: -30px;

        @include mobile {
          left: 0;
          display: block;
          margin: 0 auto 25px;
          max-width: 60;
        }
      }

      .slide-player__infos {
        > div:first-child p {
          font-weight: 600;
          @include fontSize(20);

          @include mobile {
            text-align: center;
            @include fontSize(16);
          }

          span:first-child {
            color: $orange;
          }

          span:last-child {
            color: $blue;
          }
        }
        
        > div:first-child {        
          @include mobile {
            margin-bottom: 15px;
          }
        }
      }

      .slide-player__descr {
        padding-top: 15px;
        margin-top: 15px;
        border-top: 2px dotted $blue;

        @include mobile {
          margin-top: 22px;
        }

        p {
          color: $blue;
          @include fontSize(16);
        }
      }
    }

    .slide-player__preview {
      position: absolute;
      top: 0;
      width: 10%;
      height: 100%;
      opacity: 0;
      // transition: opacity .6s ease, transform 0s 1.5s;
    }

    &.prev-active .slide-player__preview,
    &.next-active .slide-player__preview {
      opacity: 1;
      // transition: opacity .4s 1s ease, transform 0s 1s;
    }

    &.prev-active .slide-player__preview {
      right: 0;
      transform: translateX(100%);
    }

    &.next-active .slide-player__preview {
      left: 0;
      transform: translateX(-100%);
    }
  }

  .choice-character__slide {
    &.fadeIn-enter-active {
      transition: opacity .5s .5s;
    }
  }

  .slide-btn {
    position: absolute;
    top: 50%;
    width: 40px;
    height: 40px;
    background: $white;
    box-shadow: none;
    transform: translateY(calc(-50% - 10px));
    border: 0;
    padding: 0;
    cursor: pointer;
    @include defaultTransition(.4);

    @include mobile {
      top: 50px;
    }

    &::before {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 10px;
      border-bottom: 1px solid $blue;
      border-right: 1px solid $blue;
      content: '';
      @include defaultTransition(.4);
    }

    &:hover {
      background: $blue;

      &::before {
        border-color: $white;
      }
    }

    &.slide-btn--prev {
      left: 2%;

      &::before {
        left: 55%;
        transform: translate(-50%, -50%) rotate(135deg);
      }
    }

    &.slide-btn--next {
      right: 2%;

      &::before {
        left: 44%;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
  }

  .slide-player__go-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .slide-player__go {
    background: $orange;
    border-color: $orange;
    color: $white;
    text-decoration: none;
    padding: 8px 30px;
    text-transform: uppercase;
    @include fontSize(15);

    &:hover {
      border-color: $blue;
    }
  }
</style>



// WEBPACK FOOTER //
// ChoiceCharacterSlide.vue?0e945618